import React, { useState } from "react";
import useCouponCategory from "./useCategory";
import EditImg from "../../images/SideBar/Edit";
import Loader from "../../components/Loader";
import CommonDataGrid from "../../components/CommonDataGrid";
import Button from "../../components/Botton";
import { Toaster } from "react-hot-toast";
import { GridColDef } from "@mui/x-data-grid";
import { TextField } from "@mui/material";
import DeleteImg from "../../images/SideBar/Delete";
import ConfirmationModal from "../../components/ConfirmationModal/ConfirmationModal";
import { getSortByTimeButtonText } from "../../util/getSortByTimeText";
import { hasPermission } from "../../utils/permissions";
import { useAppSelector } from "../../store/hooks";
import { selectUser } from "../../store/slices/authSlice";
import { getDeleteConfirmationMessage } from "../../utils/pagePermissions";

const CouponCategory: React.FC = () => {
  const user = useAppSelector(selectUser);
  const canEdit = hasPermission(user, "coupon-category", "update");
  const canAdd = hasPermission(user, "coupon-category", "create");
  const canDelete = hasPermission(user, "coupon-category", "delete");

  const columns: GridColDef[] = [
    {
      field: "name",
      headerName: "Category Name",
      align: "center",
      headerAlign: "center",
      flex: 0.5,
      filterable: true,
    },
    {
      field: "description",
      headerName: "Description",
      align: "center",
      headerAlign: "center",
      flex: 1,
      filterable: true,
    },
  ];

  if (canEdit || canDelete) {
    columns.push({
      field: "Actions",
      headerName: "Actions",
      align: "center",
      headerAlign: "center",
      flex: 0.8,
      sortable: false,
      filterable: false,
      renderCell: (params) => (
        <div className="flex h-full items-center justify-center gap-3">
          {canEdit && (
            <button
              onClick={() => handleEdit(params.row._id, params.row?.name, params.row?.description)}
              className="text-fontColor hover:text-primary-2"
            >
              <EditImg />
            </button>
          )}
          {canDelete && (
            <button
              onClick={() => openDeleteModal(params.row._id)}
              className="text-fontColor hover:text-red-500"
            >
              <DeleteImg />
            </button>
          )}
        </div>
      ),
    });
  }

  const {
    selectedCouponCategoryId,
    selectedCouponCategoryName,
    couponCategoryData,
    loading,
    searchQuery,
    setSearchQuery,
    handleEdit,
    handleDelete,
    handleStatusUp,
    handleDateFilter,
    handleAdd,
    setFilterModel,
    setSortingModel,
    rowCount,
    paginationModel,
    setPaginationModel,
    // New time sort items
    handleSortByTime,
    timeSortOrder,
  } = useCouponCategory(columns);

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [couponCategoryToDelete, setCouponCategoryToDelete] = useState<string | null>(null);

  const openDeleteModal = (id: string) => {
    setCouponCategoryToDelete(id);
    setIsModalOpen(true);
  };

  const confirmDelete = () => {
    if (couponCategoryToDelete) {
      handleDelete(couponCategoryToDelete);
      setIsModalOpen(false);
    }
  };

  const closeDeleteModal = () => {
    setIsModalOpen(false);
    setCouponCategoryToDelete(null);
  };


  return (
    <div className="mx-auto p-4">
      {loading && <Loader />}
      {selectedCouponCategoryId ? (
        // <EditCouponCategoryIndex 
        //   couponCategoryId={selectedCouponCategoryId} 
        //   name={selectedCouponCategoryName} 
        // />
        <></>
      ) : (
        <div className=" space-y-4 mt-4 bg-white p-4 rounded-b-lg shadow-md ">
          <div className="flex justify-between items-center gap-4 mr-1 mb-4">
            <TextField
              fullWidth
              variant="outlined"
              label="Search"
              placeholder="Search By"
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)}
              size="small"
              sx={{ maxWidth: '400px' }}
            />
            <div className="flex gap-4">
              <Button
                onClick={handleSortByTime}
                className="py-1.5 px-9 rounded"
                children={getSortByTimeButtonText(timeSortOrder)}
                type="button"
              />
              {canAdd && (
                <Button
                  onClick={handleAdd}
                  className="py-1.5 px-9 rounded"
                  children="Add Category"
                  type="button"
                />
              )}
            </div>
          </div>
          <CommonDataGrid
            id="couponCategory"
            rows={couponCategoryData}
            columns={columns}
            loading={loading}
            showConfirmation={false}
            confirmationMessage={""}
            setFilterModel={setFilterModel}
            setSortingModel={setSortingModel}
            //Pagination
            paginationMode="server"
            rowCount={rowCount}
            paginationModel={paginationModel}
            onPaginationModelChange={setPaginationModel}
            onCancelDelete={function (): void {
              throw new Error("Function not implemented.");
            }}
            onConfirmDelete={function (): void {
              throw new Error("Function not implemented.");
            }}
            toolbarProps={{ toolbar: { showQuickFilter: true } }}
          />
        </div>
      )}
      <ConfirmationModal
        isOpen={isModalOpen}
        onClose={closeDeleteModal}
        onConfirm={confirmDelete}
        message={getDeleteConfirmationMessage("coupon-category")}
      />
      <Toaster />
    </div>
  );
};

export default CouponCategory;